import { images } from './images'

export type Bonus = {
  number: string
  title: string
  body: string
  cover: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Pivot Cards: 60 Mid-Session Prompts for When the Group Goes Somewhere Else',
    body: 'Print them, keep them in your pocket, pull one when the plan stops fitting the room. Three decks (Theme Starters, Develop Variations and Follow Moves), each card with its Seated Swap, so you follow the group without losing the shape of the session.',
    cover: images.bonuses[0],
  },
  {
    number: '02',
    title: 'Group Need Finder: Pick the Right Session in 30 Seconds',
    body: 'Look at who walked in, find the need, and you have your session. All 54 sessions indexed by what the group needs today (settle, activate, connect, express, move through change, close), plus length, props and group size.',
    cover: images.bonuses[1],
  },
  {
    number: '03',
    title: 'Room Setup Blueprints: 12 Layouts for Rooms That Were Never Built for Movement',
    body: 'Long narrow room? Tables that will not move? A space smaller than a parking spot? Twelve top-down layouts with setup time, a safety check and where to stand so you can see everyone.',
    cover: images.bonuses[2],
  },
  {
    number: '04',
    title: 'The Facilitator Reset: 10 Short Practices for Before, Between and After Groups',
    body: 'You hold the room all day. Ten two-to-five-minute practices to arrive before a group, shake off one before the next and leave the last one at work, each with a seated version.',
    cover: images.bonuses[3],
  },
  {
    number: '05',
    title: 'Your First Two Weeks: The Movement Group Ready Quick-Start Plan',
    body: 'A day-by-day plan for your first 14 days with the pack: what to read first, which three sessions to start with, a 15-minute solo rehearsal and what to prepare so your first group feels easy.',
    cover: images.bonuses[4],
  },
]
